import ModalHOC from './ModalHOC'
export default ModalHOC
